import getters from '../types/getter-types';

export default {
  [getters.USER]: (state) => state.user,
};
